
import {appVersionCompare, isMobileApp} from './Util';
import FactfinderSuggest from './FactfinderSuggest'


class PluscardApp {

	constructor() {
		if ( isMobileApp() ) {
			window.addEventListener( 'message', ( nativeEvent ) => this.onMessage( nativeEvent?.data ) );
		}
	}

	onMessage( message ) {
		try {
			const { type, action, payload } = JSON.parse( message ); // eslint-disable-line no-unused-vars
			if ( 'pluscard-app' === type ) {
				switch ( action ) {
					case 'open-search':
						this.openSearch();
						break;
					case 'close-search':
						this.closeSearch();
						break;
					case 'open-menu':
						this.openMenu();
						break;
					case 'close-menu':
						this.closeMenu();
						break;
				}
			}
		} catch ( err ) {
			// Not error needed.
		}
	}

	onBackButtonClick() {
		if ( isMobileApp() && 'ReactNativeWebView' in window ) {
			window.ReactNativeWebView.postMessage( 'navigation::back' );
		} else {
			window.history.back();
		}
	}

	onShareButtonClick() {
		window.ReactNativeWebView.postMessage( 'productdetail::share' );
	}

	onProductDetailView() {
		const articleDetailEl = document.querySelector( '#details_container .en_mdl_article_detail' );
		if ( !articleDetailEl ) return;

		window.ReactNativeWebView.postMessage(
			JSON.stringify( {
				type: 'productdetail::view',
				...articleDetailEl.dataset,
				imageUrl: window.location.protocol + articleDetailEl.dataset.imageUrl,
				url: location.href
			} )
		);
	}

	openMenu() {
		const menuEl = document.getElementById( 'menu_mobile' );
		menuEl.classList.add( 'is-open' );
	}

	closeMenu() {
		const menuEl = document.getElementById( 'menu_mobile' );
		menuEl.classList.remove( 'is-open' );
	}

	openSearch() {
		const searchEl = document.querySelector( '.mdl_search' );
		const instance = FactfinderSuggest.getInstance( searchEl )
		instance?.open();
	}

	closeSearch() {
		const searchEl = document.querySelector( '.mdl_search' );
		const instance = FactfinderSuggest.getInstance( searchEl )
		instance?.close();
	}
}


const PluscardAppHandler = new PluscardApp();
const initPluscardApp = ( scopeEl = document ) => {
	const buttonEl = scopeEl.getElementById( 'koegs_navigation_back' );
	if ( buttonEl ) {
		buttonEl.addEventListener( 'click', ( ev ) => {
			ev.preventDefault();
			PluscardAppHandler.onBackButtonClick();
		} );
	}

	const minVersionShare = '1.0.18';
	if ( isMobileApp() && 'ReactNativeWebView' in window && appVersionCompare( minVersionShare ) ) {
		const buttonElShare = scopeEl.getElementById( 'koegs_share' );
		if( buttonElShare && window.v_cl === 'details' ) {
			buttonElShare.parentElement.classList.remove( 'en_hidden' );
			buttonElShare.addEventListener( 'click', ( ev ) => {
				ev.preventDefault();
				PluscardAppHandler.onShareButtonClick();
			} );
		}
	}

	if ( isMobileApp() && 'ReactNativeWebView' in window ) {
		document.addEventListener( 'finished_change_variant', () => {
			PluscardAppHandler.onProductDetailView();
		} );
	}
}


export {
	PluscardAppHandler as default,
	initPluscardApp
};
